export enum Layout 
{
    REGULAR = "regular",
    SPOTLIGHT = "spotlight"
}

export interface IJoinArgs
{
    video: boolean,
    audio: boolean,
    audioOnly?: boolean
}

export type MediaType = "audio" | "video"
